<template>
  <div>
    <nav-breadcrumb :menu="[{label: ' 流水使用详情'}]"/>
    <el-row class="xzpadd10 bg-purple">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
        :is-pagination-show="false"
      >
        <div slot="TableTop">
          <el-col :span="6"><div class="Htitle-text color-deep-blue">网银交易日期：&nbsp;&nbsp;{{this.txDate|moment('YYYY-MM-DD')}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">类型：&nbsp;&nbsp;{{this.appliedUse|Status2CN}}</div></el-col>
          <el-col :span="6"><div class="Htitle-text color-deep-blue">总金额：&nbsp;&nbsp;{{this.totalAmount/10000|formatMoney}}</div></el-col>
        </div>
      </data-table>
    </el-row>
    <div class="tr xzmt">
      <el-button @click="$router.go(-1)" style="margin-top: 10px">返回</el-button>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%">
      <data-table
        :table-data="tableDataDetail"
        :columns="columnsDetail"
        :is-pagination-show="false"
      />
    </el-dialog>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN";
  import {removeItem,xmlBuildQuery} from "../../filters/CommonActions";
  import {formatMoney} from "../../filters/CommonFilters";
  import Panel from "../../components/Panel";
  export default {
    name: "BankStatementUseList",
    components: {Panel},
    data(){
      return{
        dialogVisible:false,
        appliedUse:this.$route.query['appliedUse']||'',
        txDate:this.$route.query['txDate']||'',
        totalAmount:this.$route.query['totalAmount']||'',
        columns:[
          {
            type: 'index'
          },
          {
            label: '银行流水号',
            field: 'de__bankRef'
          },
          {
            label: '摘要',
            field: 'de__digest'
          }, {
            label: '交易金额',
            field: 'de__creditAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
            width: '110px'
          },
          {
            label: '对方账号',
            field: 'de__txAccountNo'
          },
          {
            label: '对方户名',
            field: 'de__txAccountName'
          },
          {
            label: '对方银行',
            field: 'de__txBankName'
          },
          /*{
            label: '交易日期',
            field: 'de__txDate',
            formatter: (r,c,v) => {
              return moment(v).format('YYYY-MM-DD')
            },
            width: '90px'
          },*/
          {
            label: '用途',
            field: 'de__txUse'
          },
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },
          {
            label: '客户姓名',
            field: 'fi__customerName',
          },
          {
            label: '实还金额',
            field: 're__appliedRepayAmount',
            component:(r,c,v)=> {
              v = formatMoney(v)
              let showdialog = this.showdialog
              return {
                template: `<div class="Htitle-text color-danger" @click="showdialog('`+ r.de__detailId +`','`+ r.dx__appliedUse +`')">${v}</div>`,
                methods: {
                  showdialog,
                }
              }
            },
            width: '120px'
          },
          {
            label: '余额',
            field: 're__excessAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
            width: '110px'
          },
          {
            label: '余额处理',
            field: 're__excessAmountOption',
            formatter: (r,c,v) => {
              if(r.re__excessAmount<=0){
                return ''
              }else{
                return Status2CN(v)
              }
            },
          },
        ],
        tableData: {
          count: 0,
          data: []
        },
        tableDataDetail: {
          count: 0,
          data: []
        },
        columnsDetail:[
          {
            type: 'index'
          },
          {
            label: '贷款编号',
            field: 'fi__transactionNo'
          },

          {
            label: '还款日期',
            field: 're__repayDate',
            formatter: (r,c,v) => {
              return moment(v).format('YYYY-MM-DD')
            },
          },
          {
            label: '实还本金',
            field: 're__principalAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },
          {
            label: '实还利息',
            field: 're__interestAmount',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },
          {
            label: '实收罚息',
            field: 're__overdueFine',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },{
            label: '实收复利',
            field: 're__compoundInterest',
            formatter: (r,c,v) => {
              return formatMoney(v)
            },
          },

        ],
        dealerTypeOptions:[],
        page: 1,
        pageSize: 20,
        actions: [
          {
            label: '打印',
            class: 'el-icon-download',
            clickHandler: ()=>{
              this.exportPdf()
            },
          },
          {
            label: '导出',
            clickHandler:()=>{
              let routeData = this.$router.resolve({
                path: '/ix/fang/repayment/reporting/BankStatementUse.List?format=xlsx',
                query: Object.assign(
                  {
                    'dx.appliedUse':this.appliedUse,
                    'de.txDate':this.txDate,
                    'de.txDate.dateformat':'yyyy-MM-dd',
                    pageSize:0
                  },
                  {}, {})
              });
              window.open(routeData.href.replace('#/', '/'), '_blank');
            }
          }
        ],
        filters: {
          labelWidth: '150px',
          form: {
            de__bankRef:'',
            de__txAccountName:'',
            fi__transactionNo:'',
            fi__customerName:'',
          },
          columns: [
            {
              label: '流水号',
              component: 'el-input',
              field: 'de__bankRef',
            },
            {
              label: '对方户名',
              component: 'el-input',
              field: 'de__txAccountName',
            },
            {
              label: '贷款编号',
              component: 'el-input',
              field: 'fi__transactionNo',
            },
            {
              label: '客户姓名',
              component: 'el-input',
              field: 'fi__customerName',
            },
          ],
          onSubmit:()=>{
            this.page = 1
            this.getData()
          }
        }
      }
    },
    mounted() {
      if(this.appliedUse)
      this.getData()
    },
    computed: {
      filterParams() {
        return {
          pageSize: this.pageSize,
          pageOffset: (this.page - 1) * this.pageSize,
        }
      }
    },
    watch: {
      filterParams: function (newVal) {
        this.getData()
      }
    },
    filters:{
      Status2CN
    },
    methods: {
      showdialog:function(detailId,appliedUse){
        this.dialogVisible = true

        xhr.getBankStatementUseDetailList(
          Object.assign({
            'de.detailId':detailId,
            'dx.appliedUse':appliedUse,
            pageSize:0
          }, {}, {}),
          res=> {
            try {
              this.tableDataDetail = res.data
            }catch(e){

            }
          })

      },
      getData: function () {
        xhr.getBankStatementUseList(
          Object.assign({
            'dx.appliedUse':this.appliedUse,
            'de.txDate':this.txDate,
            'de.txDate.dateformat':'yyyy-MM-dd',
            pageSize:0
          }, {}, xmlBuildQuery(this.filters)),
          res=> {
            try {
              this.totalAmount = 0
              this.tableData = res.data
              this.tableData.data.forEach(item=>{
                this.totalAmount =  this.totalAmount + parseFloat( item.de__creditAmount)*10000
              })

            }catch(e){

            }
          })

      },
      exportPdf: function (index, row) {
        try {
          let bankRef = this.filters.form.de__bankRef||'-'
          let txAccountName = this.filters.form.de__txAccountName||'-'
          let transactionNo = this.filters.form.fi__transactionNo||'-'
          let customerName = this.filters.form.fi__customerName||'-'
          window.open('/ix/fang/financing/BankStatementUse.jasper?txDate='+this.$moment(this.txDate).format('YYYY-MM-DD')+'&txDate.dateformat=yyyy-MM-dd&bankRef='+bankRef+'&txAccountName='+txAccountName+'&transactionNo='+transactionNo+'&customerName='+customerName+'&appliedUse='+this.appliedUse)
        }
        catch (e) {

        }
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/BankStatementUseList.vue